import {Component} from '@angular/core';
import {MatDialogContent, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {TranslocoPipe} from '@jsverse/transloco';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'request-maintenance-policy-error-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatDialogContent,
    MatButton,
    TranslocoPipe
  ],
  standalone: true,
  templateUrl: './request-maintenance-policy-error-dialog.component.html',
})
export class RequestMaintenancePolicyErrorDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RequestMaintenancePolicyErrorDialogComponent>) {
  }
}
